module.exports = __webpack_public_path__ + "static/media/vegitables_75.dacf519b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_75.csv
// module id = 663
// module chunks = 0